var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToncoinPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_34890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9834 32.0484C25.82 32.0484 32.9834 24.885 32.9834 16.0484C32.9834 7.21185 25.82 0.0484009 16.9834 0.0484009C8.14684 0.0484009 0.983398 7.21185 0.983398 16.0484C0.983398 24.885 8.14684 32.0484 16.9834 32.0484Z",
    fill: "#0088CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5266 10.6198H21.498C21.8409 10.6198 22.1266 10.677 22.4695 10.8484C22.8695 11.0198 23.098 11.3055 23.2123 11.5341C23.2123 11.5341 23.2123 11.5912 23.2695 11.5912C23.4409 11.877 23.5552 12.2198 23.5552 12.6198C23.5552 12.9627 23.498 13.3055 23.2695 13.6484L17.6123 23.3627C17.498 23.5912 17.2695 23.7055 16.9837 23.7055C16.7552 23.7055 16.5266 23.5912 16.3552 23.3627L10.8123 13.6484C10.698 13.4198 10.4695 13.1341 10.4695 12.677C10.4123 12.277 10.5266 11.9341 10.698 11.5912C10.8695 11.2484 11.1552 10.9627 11.5552 10.8484C11.898 10.6198 12.298 10.6198 12.5266 10.6198ZM16.298 11.9912H12.5266C12.298 11.9912 12.1837 11.9912 12.1266 12.0484C12.0123 12.1055 11.9552 12.1627 11.898 12.277C11.8409 12.3341 11.8409 12.4484 11.8409 12.5627C11.8409 12.6198 11.898 12.677 12.0123 12.9055L16.298 20.3341V11.9912ZM17.6695 11.9912V20.3912L22.0123 12.9055C22.0695 12.7912 22.0695 12.677 22.0695 12.5627C22.0695 12.4484 22.0695 12.3341 22.0123 12.277C21.9552 12.2198 21.9552 12.1627 21.898 12.1627L21.8409 12.1055C21.7266 12.0484 21.6123 12.0484 21.4409 12.0484H17.6695V11.9912Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_34890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.983398 0.0484009)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToncoinPayment);
export default __webpack_public_path__ + "static/media/toncoin-payment.5b9e5c3fe9d3acca9e49359fab8a5919.svg";
export { ForwardRef as ReactComponent };